<template>
    <popup-wrapper class="popup-entity" v-if="popShow" @pop-cls="handlePopCls">
        <h3 v-html="$t('popup.entity.title', { reward: rewardName })"></h3>
        <p v-html="$t('popup.entity.desc')"></p>
        <div class="input-wrapper">
            <label for="username" v-html="$t('popup.entity.name')"></label>
            <input
                type="text"
                name="username"
                placeholder="xxxxxx"
                autocomplete="off"
                v-model="username"
                :disabled="inputedName"
            />
        </div>
        <div class="input-wrapper">
            <label for="mobile" v-html="$t('popup.entity.mobile')"></label>
            <input
                type="text"
                name="mobile"
                placeholder="xxxxxx"
                autocomplete="off"
                v-model="mobile"
                :disabled="inputedMobile"
            />
        </div>
        <div class="input-wrapper">
            <label for="email" v-html="$t('popup.entity.email')"></label>
            <input
                type="text"
                name="email"
                placeholder="xxxxxx"
                autocomplete="off"
                v-model="email"
                :disabled="inputedEmail"
            />
        </div>
        <div class="input-wrapper">
            <label for="addr" v-html="$t('popup.entity.addr')"></label>
            <input
                type="text"
                name="addr"
                placeholder="xxxxxx"
                autocomplete="off"
                v-model="address"
                :disabled="inputedAddr"
            />
        </div>
        <!-- 兑换按钮 -->
        <div class="btn-redeem" @click="handleRedeem" v-show="!inputedName">
            {{ $t('base.redeem_btn') }}
        </div>
    </popup-wrapper>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import popupWrapper from '@/components/popup/popup-wrapper';
import { isEmail, isMobile } from '@/utils';
import i18n from '@/lang';

export default {
    name: 'popup-entity',
    data() {
        return {
            username: '',
            address: '',
            email: '',
            mobile: ''
        };
    },
    components: {
        popupWrapper
    },
    computed: {
        popShow() {
            return this.$store.state.popup.entity;
        },
        // 抽中的奖品
        drawReward() {
            return this.$store.state.drawReward;
        },
        // 礼包名
        rewardName() {
            const drawReward = this.drawReward;
            if (drawReward && drawReward.type_ename == 'kind') {
                return drawReward.item_name;
            } else {
                return '';
            }
        },
        inputedName() {
            const drawReward = this.drawReward;
            if (drawReward) {
                const item = drawReward.type_info.find(
                    item => item.ename == 'user_name'
                );
                console.log(item);
                if (item && item.value) {
                    this.username = item.value;
                    return true;
                }
                return false;
            } else {
                return false;
            }
        },
        inputedMobile() {
            const drawReward = this.drawReward;
            if (drawReward) {
                const item = drawReward.type_info.find(
                    item => item.ename == 'mobile'
                );
                if (item && item.value) {
                    this.mobile = item.value;
                    return true;
                }
                return false;
            } else {
                return false;
            }
        },
        inputedAddr() {
            const drawReward = this.drawReward;
            if (drawReward) {
                const item = drawReward.type_info.find(
                    item => item.ename == 'address'
                );
                if (item && item.value) {
                    this.address = item.value;
                    return true;
                }
                return false;
            } else {
                return false;
            }
        },
        inputedEmail() {
            const drawReward = this.drawReward;
            if (drawReward) {
                const item = drawReward.type_info.find(
                    item => item.ename == 'email'
                );
                if (item && item.value) {
                    this.email = item.value;
                    return true;
                }
                return false;
            } else {
                return false;
            }
        }
    },
    methods: {
        ...mapActions(['fillDrawInfo', 'showComm']),
        ...mapMutations(['PLAY_SOUND', 'STOP_SOUND']),
        // 实物兑换
        handleRedeem() {
            this.PLAY_SOUND('button');
            this.$LOG.send_click_exchange();
            const { username, mobile, email, address } = this;
            if (!username) {
                this.showComm({
                    text: i18n.t('base.enter_name'),
                    size: 'mid'
                });
                return;
            }
            if (!mobile) {
                this.showComm({
                    text: i18n.t('base.enter_phone'),
                    size: 'mid'
                });
                return;
            }
            if (!email) {
                this.showComm({
                    text: i18n.t('base.enter_email'),
                    size: 'mid'
                });
                return;
            }
            if (!isEmail(email)) {
                this.showComm({
                    text: i18n.t('base.enter_right_email'),
                    size: 'mid'
                });
                return;
            }
            if (!address) {
                this.showComm({
                    text: i18n.t('base.enter_address'),
                    size: 'mid'
                });
                return;
            }
            this.fillDrawInfo({
                id: this.drawReward.id,
                user_name: username,
                mobile,
                email,
                address
            });
        },
        handlePopCls() {
            this.$store.commit('HIDE_ALL_POPUP');
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .popup-wrapper {
    box-sizing: border-box;
    padding: 40px 40px;

    h3 {
        font-size: 32px;
        color: #9c9273;
        text-align: center;
        margin-bottom: 16px;
        line-height: 1.2;
    }

    p {
        font-size: 24px;
        text-align: center;
        line-height: 1.5;
        color: #9c9273;
    }

    .input-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 22px;
        margin-left: 12px;

        label {
            font-size: 24px;
            color: #474747;
            margin-right: 24px;
            text-align: center;
            width: 30%;
        }

        input {
            // width: 344px;
            width: 70%;
            height: 55px;
            background: url(~@/assets/img/pop_input_bg.png) center/100% 100%
                no-repeat;
            padding-left: 20px;
            box-sizing: border-box;
            font-size: 24px;
            line-height: 55px;
            color: #9c9273;
            flex-shrink: 0;

            &::-webkit-input-placeholder {
                color: #e7e2d0;
            }
        }
    }

    .btn-redeem {
        width: 189px;
        height: 74px;
        background: url(~@/assets/img/btn_blue_square.png) center/100% 100%
            no-repeat;
        margin: 40px auto 0;
        line-height: 74px;
        font-size: 34px;
        color: #fff;
        text-align: center;
        font-weight: bold;
    }
}
</style>
